// Shared timezone helpers for booking UIs.
export const TIMEZONES = [
  { value: "Pacific/Honolulu", label: "Hawaii (HAST)" },
  { value: "America/Anchorage", label: "Alaska (AKST/AKDT)" },
  { value: "America/Los_Angeles", label: "Pacific — Los Angeles" },
  { value: "America/Denver", label: "Mountain — Denver" },
  { value: "America/Phoenix", label: "Arizona (no DST)" },
  { value: "America/Chicago", label: "Central — Chicago" },
  { value: "America/New_York", label: "Eastern — New York" },
  { value: "America/Halifax", label: "Atlantic — Halifax" },
  { value: "America/Sao_Paulo", label: "São Paulo (BRT)" },
  { value: "UTC", label: "UTC" },
  { value: "Europe/London", label: "London (GMT/BST)" },
  { value: "Europe/Paris", label: "Paris / Berlin (CET/CEST)" },
  { value: "Europe/Athens", label: "Athens / Cairo (EET/EEST)" },
  { value: "Africa/Johannesburg", label: "Johannesburg (SAST)" },
  { value: "Asia/Dubai", label: "Dubai (GST)" },
  { value: "Asia/Kolkata", label: "India (IST)" },
  { value: "Asia/Bangkok", label: "Bangkok / Jakarta" },
  { value: "Asia/Singapore", label: "Singapore / Hong Kong" },
  { value: "Asia/Tokyo", label: "Tokyo / Seoul" },
  { value: "Australia/Sydney", label: "Sydney (AEST/AEDT)" },
  { value: "Pacific/Auckland", label: "Auckland (NZST/NZDT)" },
];

export const detectTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York";
  } catch {
    return "America/New_York";
  }
};

// Format an ISO instant in a specific timezone.
export const formatInTz = (iso, tz, opts = {}) => {
  try {
    return new Intl.DateTimeFormat(undefined, { timeZone: tz, ...opts }).format(new Date(iso));
  } catch {
    return new Date(iso).toLocaleString();
  }
};

// Convert a wall-clock (YYYY-MM-DD, HH:mm) in a timezone → a UTC ISO string.
export const wallTimeToIso = (dateStr, timeStr, tz) => {
  if (!dateStr || !timeStr) return null;
  // Treat the pair as a UTC candidate first.
  const naive = new Date(`${dateStr}T${timeStr}:00Z`);
  if (isNaN(naive.getTime())) return null;
  // Read what that same instant *looks like* in the target TZ vs UTC to derive its offset.
  const asTz = new Date(naive.toLocaleString("en-US", { timeZone: tz }));
  const asUtc = new Date(naive.toLocaleString("en-US", { timeZone: "UTC" }));
  const offsetMs = asTz.getTime() - asUtc.getTime();
  return new Date(naive.getTime() - offsetMs).toISOString().replace(".000Z", "Z");
};
